import { RateEvent, ReportEventsRsp } from "../model/Rate";
import { requestBackend } from "./common";

interface ReportVisitQuestionEventProps {
    userID: string;
    event: RateEvent;
    afterSuccess: () => void;
    dispatch: any;
}

export function ReportVisitQuestionEvent(props: ReportVisitQuestionEventProps) {
    const { afterSuccess, dispatch, userID, event } = props;
    const req_data = {
        user_id: userID,
        event: event,
    };
    requestBackend({
        uri: `/api/event/visit_question`,
        req_data: req_data,
        handleRsp: (rsp_json: any) => {
            let rsp = new ReportEventsRsp();
            Object.assign(rsp, rsp_json);
            afterSuccess();
            return rsp;
        },
        errTitle: "",
        dispatch,
    });
}
